import AccordionComponent from '../../common/Accordion';
import CustomCheckbox from '../../common/Checkbox';
import RadioGroupComponent from '../../common/RadioGroup';
import styles from './styles';
import { IContentFilterModalProps } from './types';

const statusData = [
    {
        value: 'active',
        label: 'Active',
    },
    {
        value: 'inActive',
        label: 'Inactive',
    },
];

const ContentFilterModal = ({
    selectedStatus,
    onStatusChange,
    onCategoryChange,
    onAuthorChange,
    categories,
    authors,
}: IContentFilterModalProps) => {
    const selectedFiltersCount =
        authors.filter((it) => it.checked).length + categories.filter((it) => it.checked).length;

    return (
        <>
            <AccordionComponent
                data={[
                    {
                        summary: 'Visibility Status',
                        detailsNode: (
                            <RadioGroupComponent
                                classes={styles.radioGroupLabel}
                                data={statusData}
                                selectedValue={selectedStatus}
                                name="status"
                                onChange={onStatusChange}
                            />
                        ),
                    },
                    {
                        summary: 'Authors',
                        detailsNode: (
                            <CustomCheckbox
                                classes={styles.radioGroupLabel}
                                data={authors.map((author) => ({
                                    value: author.id,
                                    label: author.name,
                                    checked: author.checked,
                                }))}
                                name="author"
                                onChange={onAuthorChange}
                                disabled={selectedFiltersCount >= 10}
                            />
                        ),
                    },
                    {
                        summary: 'Tags',
                        detailsNode: (
                            <CustomCheckbox
                                classes={styles.radioGroupLabel}
                                data={categories.map((category) => ({
                                    value: category.id,
                                    label: category.name,
                                    checked: category.checked,
                                }))}
                                name="category"
                                onChange={onCategoryChange}
                                disabled={selectedFiltersCount >= 10}
                            />
                        ),
                    },
                ]}
            />
        </>
    );
};
export default ContentFilterModal;
